import React from 'react';

const CustomLoader = ({ logo, size = 'medium' }) => {
  // Default logo fallback
  const defaultLogo = (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 100 100" 
      className="fill-blue-600"
    >
      <circle cx="50" cy="50" r="40" />
    </svg>
  );

  // Size variations
  const sizeClasses = {
    small: 'w-12 h-12',
    medium: 'w-24 h-24',
    large: 'w-40 h-40'
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/70 z-50">
      <div className={`relative ${sizeClasses[size]} animate-pulse`}>
        {/* Rotating Container */}
        <div className="absolute inset-0 animate-spin">
          {/* Circular Spinner */}
          <div className="absolute inset-0 border-4 border-blue-100 border-t-blue-600 rounded-full"></div>
        </div>

        {/* Logo in Center */}
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <div className="w-2/3 h-2/3">
            {logo || defaultLogo}
          </div>
        </div>
      </div>
    </div>
  );
};


export default CustomLoader;